import { render, staticRenderFns } from "./recover-password.vue?vue&type=template&id=902b7b3e&scoped=true&"
import script from "./recover-password.vue?vue&type=script&lang=js&"
export * from "./recover-password.vue?vue&type=script&lang=js&"
import style0 from "./recover-password.vue?vue&type=style&index=0&id=902b7b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902b7b3e",
  null
  
)

export default component.exports